export class School {
  id: string;
  name: string;
}
